// Recently Viewed Action Types

// Record a view event (fire-and-forget)
export const RECORD_RECENTLY_VIEWED = "RECORD_RECENTLY_VIEWED";

// Get the current user's recently viewed list
export const GET_RECENTLY_VIEWED_LIST = "GET_RECENTLY_VIEWED_LIST";
export const GET_RECENTLY_VIEWED_LIST_SUCCESS =
  "GET_RECENTLY_VIEWED_LIST_SUCCESS";
export const GET_RECENTLY_VIEWED_LIST_FAIL = "GET_RECENTLY_VIEWED_LIST_FAIL";
